import { Media } from '@/styles';
import styled from '@emotion/styled';

const ToolBoxButtonIcon = (): JSX.Element => {
  return (
    <Svg
      width="5"
      height="18"
      viewBox="0 0 5 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.13281 2.63893C4.1329 2.89079 4.08125 3.1402 3.98082 3.37292C3.88039 3.60564 3.73314 3.81711 3.54748 3.99525C3.36182 4.1734 3.14139 4.31474 2.89877 4.41119C2.65615 4.50765 2.3961 4.55734 2.13346 4.55742C1.87081 4.5575 1.61072 4.50797 1.36804 4.41167C1.12536 4.31536 0.90483 4.17416 0.719053 3.99612C0.533276 3.81809 0.385887 3.60671 0.2853 3.37406C0.184713 3.1414 0.132897 2.89202 0.132813 2.64017C0.132642 2.13152 0.343193 1.64363 0.718145 1.28385C1.0931 0.924061 1.60174 0.721843 2.13217 0.72168C2.6626 0.721516 3.17138 0.92342 3.54657 1.28298C3.92176 1.64253 4.13264 2.13028 4.13281 2.63893V2.63893Z"
        fill="white"
      />
      <path
        d="M2.13217 11.1387C3.23638 11.1387 4.13153 10.2803 4.13153 9.22145C4.13153 8.16258 3.23638 7.3042 2.13217 7.3042C1.02795 7.3042 0.132812 8.16258 0.132812 9.22145C0.132812 10.2803 1.02795 11.1387 2.13217 11.1387Z"
        fill="white"
      />
      <path
        d="M2.13217 17.7212C3.23638 17.7212 4.13153 16.8628 4.13153 15.804C4.13153 14.7451 3.23638 13.8867 2.13217 13.8867C1.02795 13.8867 0.132812 14.7451 0.132812 15.804C0.132812 16.8628 1.02795 17.7212 2.13217 17.7212Z"
        fill="white"
      />
    </Svg>
  );
};

const Svg = styled.svg`
  @media ${Media.sm} {
    width: 0.313rem;
    height: 0.875rem;
  }
  @media ${Media.md} {
    width: 0.313rem;
    height: 1.125rem;
  }
  @media ${Media.lg} {
    width: 0.313rem;
    height: 1.125rem;
  }
`;

export default ToolBoxButtonIcon;
